const removeHTMLTags = str => {
  const tmp = document.createElement('DIV')
  tmp.innerHTML = str
  return tmp.textContent || tmp.innerText || ''
}

export default removeHTMLTags
